import React from 'react'
import { components } from 'cng-web-lib'
import { useHistory, useLocation } from 'react-router-dom'
import ViewFtaProductDetailsFormProperties from './ViewFtaProductDetailsFormProperties'
import { Yup } from 'cng-web-lib'
import TradeManagementTranslationText from '../shared/TradeManagementTranslationText'

const {
  form: { CngViewForm }
} = components

function ViewFtaProductDetailsPage({ showNotification, ...props }) {
  const history = useHistory()
  const location = useLocation()
  const {
    location: { pathname }
  } = props
  const historyData = location.state

  console.log('check here props 123123123 ::', historyData?.productStatusCode)


  // Locale
  const FtaTranslatedTextsObject = TradeManagementTranslationText()

  function onSubmit(data) {
    // console.log('View product details :: onSubmit ::\n', data)
  }

  return (
    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <ViewFtaProductDetailsFormProperties.FormFields
          disabled={false}
          showNotification={showNotification}
          pathname={pathname}
          productStatusCode={historyData?.productStatusCode}
        />
      }
      formikProps={{
        // initialValues: {},
        ...ViewFtaProductDetailsFormProperties.formikProps,
        onSubmit: onSubmit
      }}
    />
  )
}

export default ViewFtaProductDetailsPage
